import { PageRoute } from './generated/enums'

export enum AppSettingsDefaultLandingPages {
  ALERTS = 'alerts',
  ANALYTICS = 'analytics',
  ALL_ALERTS = 'all_alerts',
  HOMEPAGE = 'homepage',
}

export const AppSettingsDefaultLandingPageToRoute = {
  [AppSettingsDefaultLandingPages.ALERTS]: PageRoute.ALERTS,
  [AppSettingsDefaultLandingPages.ANALYTICS]: PageRoute.ANALYTICS + '/overview',
  [AppSettingsDefaultLandingPages.ALL_ALERTS]: PageRoute.UNIFIED_ALERTS + '/domains',
  [AppSettingsDefaultLandingPages.HOMEPAGE]: '/',
}
